export default __webpack_public_path__ + "locales/pl/BackupCodesDialog.json?hash=4d6b0784a002b6bd93c8678a1a0a3d8e";